/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsRecommendedProducts = {
  init: function($section) {
    if ($section.data('recommended-products-initialized')) return;
    $section.data('recommended-products-initialized', true);

    const sectionData = window.PXUTheme.getSectionData($section);

    // Look for an element with class 'product-recommendations'
    const $productRecommendations = $section.find('.product-recommendations');
    if (!$productRecommendations.length) return;

    // Selectors
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');
    const minProducts = Math.min(Number($productRecommendations.data('min-products')), Number(limit));

    const sectionID = $productRecommendations.data('section-id');
    const shopURL = $productRecommendations.data('base-url');

    const mobileMediaQuery = window.matchMedia('(max-width: 798px)');
    const handleBreakpointChange = () => window.PXUTheme.jsProduct.relatedProducts($section);

    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mobileMediaQuery.addListener(handleBreakpointChange);
    }

    $section.data('recommended-products-media-query', mobileMediaQuery);
    $section.data('recommended-products-breakpoint-handler', handleBreakpointChange);

    // If showing custom collection we do not want to build request url
    if (sectionData.show_custom_collection) {
      if (sectionData.recommendation_source === 'metafield') {
        this.loadAdditionalRecommendations({
          $productRecommendations,
          sectionID,
          shopURL,
          productID,
          minProducts,
          sourceProductIDs: sectionData.recommendation_product_ids,
        }).then(() => {
          this.showCustomCollection($section);

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        });
      } else {
        this.showCustomCollection($section);
      }

      return;
    }

    // Initialize the server-rendered fallback products while Shopify recommendations load.
    window.PXUTheme.jsProduct.relatedProducts($section);

    // Build request URL
    const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

    $.ajax({
      type: 'GET',
      url: requestUrl,
      success: async (data) => {

        let $recommendedProductsElement = $(data).find('.product-recommendations').html();

        $productRecommendations.find('.flickity-enabled').each((_, slider) => {
          const $slider = $(slider);

          if ($slider.data('flickity')) {
            $slider.off('.relatedProducts').flickity('destroy');
          }
        });

        // Insert product list into the product recommendations container
        $productRecommendations.html($recommendedProductsElement);

        await this.loadAdditionalRecommendations({
          $productRecommendations,
          sectionID,
          shopURL,
          productID,
          minProducts,
        });

        window.PXUTheme.jsProduct.relatedProducts($section);

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
      }
    });
  },
  loadAdditionalRecommendations: async function({
    $productRecommendations,
    sectionID,
    shopURL,
    productID,
    minProducts,
    sourceProductIDs,
  }) {
    const cardSelector = '.product__grid-item, .gallery-cell';
    const getCardKey = (card) => {
      const href = $(card).find('a[href]').first().attr('href');

      if (!href) return null;

      try {
        return new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        return href;
      }
    };
    const getCardsContainer = () => {
      const $slider = $productRecommendations.find('.js-related-products-slider .products-slider').first();

      if ($slider.length) return $slider;

      return $productRecommendations.find('[data-recommendations-products-container]').first();
    };
    const $cardsContainer = getCardsContainer();

    if (!$cardsContainer.length || !minProducts) return;

    const existingKeys = new Set();
    $cardsContainer.find(cardSelector).each((_, card) => {
      const key = getCardKey(card);
      if (key) existingKeys.add(key);
    });
    let renderedProductsCount = existingKeys.size;
    const currentProductKey = window.location.pathname.replace(/\/$/, '');

    existingKeys.add(currentProductKey);

    if (renderedProductsCount >= minProducts) return;

    const recommendationsJsonUrl = shopURL.replace(/\/products(?:\.json)?$/, '/products.json');

    try {
      let products;

      if (Array.isArray(sourceProductIDs) && sourceProductIDs.length) {
        products = sourceProductIDs.map(id => ({ id }));
      } else {
        const response = await fetch(
          `${recommendationsJsonUrl}?limit=10&product_id=${encodeURIComponent(productID)}&intent=related`
        );

        if (!response.ok) return;

        const data = await response.json();
        products = data.products || [];
      }

      for (const sourceProduct of products) {
        if (renderedProductsCount >= minProducts) break;

        const requestUrl = `${shopURL}?section_id=${encodeURIComponent(sectionID)}&limit=10&product_id=${encodeURIComponent(sourceProduct.id)}`;
        const secondaryResponse = await fetch(requestUrl);

        if (!secondaryResponse.ok) continue;

        const secondaryHtml = await secondaryResponse.text();
        const $secondaryRecommendations = $(secondaryHtml).find('.product-recommendations');

        $secondaryRecommendations.find(cardSelector).each((_, card) => {
          if (renderedProductsCount >= minProducts) return false;

          const key = getCardKey(card);

          if (!key || existingKeys.has(key)) return;

          existingKeys.add(key);
          $cardsContainer.append(card);
          renderedProductsCount += 1;
        });
      }
    } catch (error) {
      console.warn('Unable to load additional product recommendations.', error);
    }
  },
  setupRecommendedVideoPlayer: function($section) {
    const videosInRecommendedProducts = $section.find('[data-product-recommendations-container] [data-html5-video] video, [data-product-recommendations-container] [data-youtube-video]').get();

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (videoPlayers !== null) {
        var combinedArray = videoPlayers.concat(videosInRecommendedProductsPlayer);
        videoPlayers = combinedArray;
      } else {
        videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    window.PXUTheme.jsVideo.setupListeners();
  },
  showCustomCollection: function($section) {
    window.PXUTheme.jsProduct.relatedProducts($section);
  },
  unload: function($section) {
    const mobileMediaQuery = $section.data('recommended-products-media-query');
    const handleBreakpointChange = $section.data('recommended-products-breakpoint-handler');

    if (!mobileMediaQuery || !handleBreakpointChange) return;

    if (mobileMediaQuery.removeEventListener) {
      mobileMediaQuery.removeEventListener('change', handleBreakpointChange);
    } else {
      mobileMediaQuery.removeListener(handleBreakpointChange);
    }
  }
}

function initRecommendedProductSections() {
  if (!window.jQuery || !window.PXUTheme || !window.PXUTheme.jsProduct) {
    setTimeout(initRecommendedProductSections, 50);
    return;
  }

  const $ = window.jQuery;

  $('.shopify-section.jsRecommendedProducts').each(function() {
    window.PXUTheme.jsRecommendedProducts.init($(this));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecommendedProductSections);
} else {
  initRecommendedProductSections();
}

/******/ })()
;
